import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 12l4 3l-8 7l-8 -7l4 -3","key":"svg-0"}],["path",{"d":"M12 3l-8 6l8 6l8 -6z","key":"svg-1"}],["path",{"d":"M12 15h8","key":"svg-2"}]]

const IconBrandSuperhuman = createReactComponent('outline', 'brand-superhuman', 'BrandSuperhuman', __iconNode);

export default IconBrandSuperhuman;